import React, { Component } from 'react';
import axios from 'axios'  
import Login  from '../Login.js'
import Management  from './Management.js'
import Server from './../Server.js'
import { connect } from 'react-redux';

class Admin extends React.Component {
  constructor(props){
    super(props);
    this.Server = new Server();

    this.state={
      Show:false,
      Aute :  this.props.Autenticated ?  this.props.Autenticated : false,
      absoluteUrl: this.Server.getAbsoluteUrl(),
      url: this.Server.getUrl(1)

    }
    
    
  }
  componentDidMount(){
    axios.post(this.state.url+'checktoken', {
      token: localStorage.getItem("api_token")
    })
    .then(response => {
      if(response.data.authData.level == "0")
        return;
        if(!this.props.systemId){
          this.props.dispatch({
            type: "LoginTrueUser",
            systemId : localStorage.getItem("systemId")
            || response.data?.authData?.systemId
          });
        }
      this.setState({
        Aute : true,
        Show:true
      })
    })
    .catch(error => {
      this.setState({
        Show:true
      })
      console.log(error)
    })
  }
 
    render(){
        return (
            this.state.Show ?
            this.state.Aute ?
              <Management />
                :
              <Login admin="1" />
            :
            <div></div>  
        )
    }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  }
}
export default   connect(mapStateToProps)(Admin);